import Vue from 'vue'
import router from '../../../router'

export const mKasa = {
    state: {
        status: 'idle',
        mKasa: null,
        saleItems: null,
        promoItems: null,
        pagination: {
            page: 1,
            totalPages: 0,
            perPage: 999,
            totalRecords: null
        },
        filters: {
            shopIds: {
                type: 'ui-virtual-list',
                value: null,
                searcher: false,
                label: 'Wybierz sklep',
                moduleName: 'merchants',
                fetchAction: 'merchantsFetch',
                getter: 'getLocationIdsForSelect',
                disabledLinkGenerator: true
            },
            year: {
                type: 'dropdown',
                value: null,
                moduleName: 'mKasa',
                getter: 'getMKasaYears',
                text: 'Rok'
            }
        },
        mKasaYears: null,
        widgetLocationId: null
    },
    mutations: {
        SET_MKASA_STATUS(state, payload) {
            state.status = payload
        },
        SET_MKASA_SALE_ITEMS(state, payload) {
            state.saleItems = payload
        },
        SET_MKASA_PROMO_ITEMS(state, payload) {
            state.promoItems = payload
        },
        SET_MKASA_TOTALPAGES(state, payload) {
            state.pagination.totalPages = payload
        },
        SET_MKASA_TOTALRECORDS(state, payload) {
            state.pagination.totalRecords = payload
        },
        SET_MKASA_CURRENT(state, payload) {
            state.pagination.page = payload
        },
        SET_MKASA_PERPAGE(state, payload) {
            state.pagination.perPage = payload
        },
        SET_MKASA_FILTER(state, payload) {
            if (payload.filter === 'year' && !payload.value) return
            Vue.set(state.filters[payload.filter], 'value', payload.value)
        },
        RESET_MKASA_FILTERS(state, payload) {
            Vue.set(state, 'filters', payload)
            Vue.set(state.filters.year, 'value', Math.max(...state.mKasaYears))
        },
        SET_MKASA_YEARS(state, payload) {
            state.mKasaYears = payload
        },
        SET_MKASA_WIGDET_LOCATIONID(state, payload) {
            state.widgetLocationId = payload
        }
    },
    actions: {
        async mKasaFetch({ commit, state, dispatch }, payload) {
            commit('SET_MKASA_STATUS', 'loading')

            if (router.currentRoute.query.page) {
                commit('SET_MKASA_CURRENT', +router.currentRoute.query.page)
            }
            if (router.currentRoute.query.show) {
                commit('SET_MKASA_PERPAGE', +router.currentRoute.query.show)
            }

            let locationId = state.filters.shopIds.value
                ? state.filters.shopIds.value
                : null
            if (payload && payload.location_id) locationId = payload.location_id
            if (!locationId) {
                commit('SET_MKASA_PROMO_ITEMS', null)
                commit('SET_MKASA_SALE_ITEMS', null)

                commit('SET_MKASA_TOTALRECORDS', null)
                commit('SET_MKASA_TOTALPAGES', 0)
                return
            }

            const pagination = {
                page: state.pagination.page,
                per: state.pagination.perPage
            }
            const params = {
                ...pagination,
                ...payload,
                location_id: locationId,
                date_at: state.filters.year.value
                    ? `${state.filters.year.value}-01,${state.filters.year.value}-12`
                    : null
            }

            await dispatch('mKasaSaleItemsFetch', params)
            await dispatch('mKasaPromoItemsFetch', params)
            commit('SET_MKASA_STATUS', 'idle')
        },
        mKasaSaleItemsFetch({ commit, state, dispatch }, params) {
            return this.$api
                .get('reports/mkasa/sale_items', { params })
                .then(res => {
                    commit(
                        'SET_MKASA_TOTALRECORDS',
                        +res.data.pagination[0].totalRecords
                    )
                    commit(
                        'SET_MKASA_TOTALPAGES',
                        +res.data.pagination[0].totalPages
                    )
                    commit('SET_MKASA_SALE_ITEMS', res.data.data)
                })
                .catch(err => {
                    console.log(err)
                    commit('SET_MKASA_STATUS', 'idle')
                })
        },
        mKasaPromoItemsFetch({ commit }, params) {
            return this.$api
                .get('reports/mkasa/promo_items', { params })
                .then(res => {
                    commit('SET_MKASA_PROMO_ITEMS', res.data.data)
                    commit('SET_MKASA_STATUS', 'idle')
                })
                .catch(err => {
                    console.log(err)
                    commit('SET_MKASA_STATUS', 'idle')
                })
        },
        mKasaYearsFetch({ commit }) {
            return this.$api
                .get('reports/mkasa/sale_items', {
                    params: {
                        per: 9999
                    }
                })
                .then(res => {
                    let years = res.data.data.map(el => el.year)
                    if (!years) return []
                    years = [...new Set(years)]
                    commit('SET_MKASA_FILTER', {
                        filter: 'year',
                        value: Math.max(...years)
                    })
                    commit('SET_MKASA_YEARS', years)
                    return years
                })
                .catch(err => {
                    console.log(err)
                })
        },
        setMKasaCurrentYear({ state, commit }) {
            if (state.mKasaYears) {
                commit('SET_MKASA_FILTER', {
                    filter: 'year',
                    value: state.mKasaYears[state.mKasaYears.length - 1]
                })
            }
        },
        setMKasaWidgetLocationId({ commit }, payload) {
            commit('SET_MKASA_WIGDET_LOCATIONID', payload)
        }
    },
    getters: {
        getMKasa: state => {
            if (state.saleItems && state.promoItems) {
                return [
                    {
                        title: 'Realizacja warunków sprzedażowych',
                        component: 'MKasaSaleItems',
                        data: state.filters.year.value
                            ? state.saleItems.filter(
                                el => el.year === state.filters.year.value
                            )
                            : state.saleItems
                    },
                    {
                        title: 'Realizacja warunku użyć promocji',
                        component: 'MKasaPromoItems',
                        data: state.filters.year.value
                            ? state.promoItems.filter(
                                el => el.year === state.filters.year.value
                            )
                            : state.promoItems
                    }
                ]
            }
        },
        getMKasaStatus: state => {
            return state.status
        },
        getMKasaPagination: state => {
            return state.pagination
        },
        getMKasaFilters: state => {
            return state.filters
        },
        getMKasaYears: state => {
            if (state.mKasaYears) {
                return state.mKasaYears.map(el => {
                    return {
                        label: el,
                        value: el
                    }
                })
            }
        },
        isMKasaDisplay: state => {
            return {
                conditional: !state.filters.shopIds.value,
                text: 'Aby zobaczyć raport, należy wybrać sklep z listy'
            }
        },
        getMKasaWidgetLocationId: state => {
            return state.widgetLocationId
        },
        mKasaService: (state, getters) => {
            return getters.getServices.find(
                el =>
                    el.code === 'fina' &&
                    el.number_of_entities_with_subscription > 0
            )
        }
    }
}
